import _ from "lodash";
import React from "react";
import { Modal } from "@toddle-edu/ds-web";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./GlobalSearchBarSkeleton.scss";

const CHIP_COUNT = 7;
const ROW_COUNT = 6;

const GlobalSearchBarSkeleton = ({ onClose }) => {
  return (
    <Modal
      dsVersion="2.0"
      width="888px"
      height="588px"
      isOpen={true}
      onClose={onClose}
    >
      <Modal.Body isScrollable>
        <div className={classes.container}>
          <div className={classes.searchBar}>
            <div className={classes.searchInputArea}>
              <SkeletonLoader width="20px" height="20px" variant="circular" />
              <div className={classes.searchTextFill}>
                <SkeletonLoader width="100%" height="16px" variant="rounded" />
              </div>
            </div>
            <div className={classes.dropdownArea}>
              <SkeletonLoader width="100%" height="20px" variant="rounded" />
            </div>
          </div>
          <div className={classes.chipsRow}>
            {_.times(CHIP_COUNT, index => (
              <SkeletonLoader
                key={index}
                width="80px"
                height="28px"
                variant="rounded"
              />
            ))}
          </div>

          <div className={classes.resultList}>
            {_.times(ROW_COUNT, index => (
              <div key={index} className={classes.resultRow}>
                <SkeletonLoader width="32px" height="32px" variant="circular" />
                <div className={classes.rowText}>
                  <SkeletonLoader width="60%" height="14px" variant="rounded" />
                  <SkeletonLoader width="40%" height="12px" variant="rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.footer}>
          <SkeletonLoader width="200px" height="16px" variant="rounded" />
          <SkeletonLoader width="140px" height="16px" variant="rounded" />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default GlobalSearchBarSkeleton;
